import axios from 'axios';

export default {
  getConsolidatePO(params = {}) {
    return axios.get('/v1/purchasing-orders/report/monthly', { params });
  },
  uploadPO(data, params) {
    return axios.post('/v1/purchasing-orders/upload-monthly', data, { params });
  },
  uploadIO(data, params) {
    return axios.post('/v1/io/upload-monthly', data, { params });
  },
  editPO(id, params) {
    return axios.patch(`/v1/purchasing-orders/report/monthly/${id}`, params);
  },
  editIO(id, params) {
    return axios.patch(`/v1/io/monthly/${id}`, params);
  },
  getConsolidateIO(params = {}) {
    return axios.get('/v1/io/report-monthly', { params });
  },
  getSummary(params = {}) {
    return axios.get('/v1/io/summary-monthly', { params });
  },
  getTemplate(params = {}) {
    return axios.get('/v2/integration/download', {
      params,
      responseType: 'blob'
    });
  }
};
